:host {
  --backdrop-color: var(--color-white);
}

.fix-product-tile {
  position: relative;
  font-family: var(--primary-font);
  color: var(--color-white);
  font-weight: 600;
  width: 100%;
  height: 100%;
  max-width: 320px;

  &.desktop {
    font-size: 25px;
    display: none;

    @include breakpointMin('md') {
      display: block;
    }

    lilu-button {
      position: absolute;
      width: calc(100% - 40px);
      left: 20px;
      right: 20px;
      bottom: 20px;
      z-index: 4;
    }

    .backdrop {
      position: absolute;
      top: -5px;
      left: -17px;
      width: calc(100% + 17px);
      height: calc(100% + 5px);
      background-color: var(--backdrop-color);
      @include layerIndex('second');

      @include breakpointMin('lg') {
        height: calc(100% + 5px + 110px);
      }
    }

    ::slotted(img) {
      position: absolute;
      @include layerIndex('third');
    }
  }

  &.mobile {
    display: block;
    font-size: 20px;
    @include breakpointMin('sm') {
      font-size: 25px;
    }

    @include breakpointMin('md') {
      display: none;
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 20px;
      width: 100%;
      z-index: 4;
    }
  }

  div.text {
    position: absolute;
    top: 20px;
    left: 20px;
    padding-right: 20px;
    z-index: 4;

    &.White{
      color: white;
    }
    &.Silver{
      color: silver;
    }
    &.Cherryade{
      color: var(--color-livique-cherryade);
    }
    &.Nero{
      color: var(--color-nero);
    }
    &.Bleached-Silk{
      color: var(--color-bleached-silk);
    }
    &.Anthrazit{
      color: var(--color-livique-anthrazit);
    }
    &.Green-Seduction{
      color: var(--color-livique-green-seduction);
    }
  }

  ::slotted(img) {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
